import { render, staticRenderFns } from "./CreateSGPoolConfigs.vue?vue&type=template&id=16d7cc5a&scoped=true"
import script from "./CreateSGPoolConfigs.vue?vue&type=script&lang=js"
export * from "./CreateSGPoolConfigs.vue?vue&type=script&lang=js"
import style0 from "./CreateSGPoolConfigs.vue?vue&type=style&index=0&id=16d7cc5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d7cc5a",
  null
  
)

export default component.exports